import { render, staticRenderFns } from "./nice.vue?vue&type=template&id=22e24117&scoped=true&"
import script from "./nice.vue?vue&type=script&lang=js&"
export * from "./nice.vue?vue&type=script&lang=js&"
import style0 from "./nice.vue?vue&type=style&index=0&id=22e24117&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e24117",
  null
  
)

export default component.exports